// extracted by mini-css-extract-plugin
export default {"container":"ReportFeedbackButton_container__7980w"};